// Direct checkout destination for the single Maestro en Pista offer.
export const BASE_CHECKOUT_URL =
  'https://monitor-padel.impultienda.ar/checkout?utm_source=facebook&utm_medium=paid&utm_campaign={{campaign.name}}&utm_term={{adset.name}}&utm_content={{ad.name}}&utm_id={{ad.id}}';
